import {
  DeleteTreatyEndorsement,
  DeleteTreatyEndorsementVariables,
} from "_graphql/mutation/__generated__/DeleteTreatyEndorsement";

import { LocationGenerics } from "router/location";
import { PopUp } from "components";
import { deleteTreatyEndorsement } from "_graphql/visal/mutations/treaty";
import toast from "react-hot-toast";
import { useMutation } from "@apollo/client";
import { useSearch } from "react-location";

export default function RemoveContainer({
  open,
  setOpen,
  refetch,
}: {
  open: boolean;
  setOpen: (val: boolean) => void;
  refetch?: () => void;
}) {
  const searchParams = useSearch<LocationGenerics>();
  const [remove, { loading }] = useMutation<
    DeleteTreatyEndorsement,
    DeleteTreatyEndorsementVariables
  >(deleteTreatyEndorsement, {
    refetchQueries: ["GetTreatyEndorsements", "Treaty"],
  });

  const handleSubmit = async () => {
    await remove({
      variables: {
        treatyEndorsementId: searchParams?.id || "",
      },
    })
      .then(({ data }) => {
        if (data?.deleteTreatyEndorsement) {
          toast.success("Endorsement Removed Successfully");
          refetch?.();
          setOpen?.(false);
        } else {
          toast.error("Could not remove endorsement");
        }
      })
      .catch((error) => {
        toast.error("Could not remove endorsement");
      });
  };

  return (
    <PopUp
      open={open}
      setOpen={setOpen}
      title="Delete Endorsement"
      cancelText="No, Don't Delete Endorsement"
      description="This action would completely remove endorsement details from system"
      renderActions={() => (
        <>
          <button
            type="button"
            disabled={loading}
            className="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-red-600 text-base font-medium text-white hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 sm:ml-3 sm:w-auto sm:text-sm"
            onClick={handleSubmit}
          >
            {loading ? "Removing Endorsement..." : "Remove Endorsement"}
          </button>
        </>
      )}
    />
  );
}
